<template>
  <div style="width:100%;height:100%;overflow-y:auto;background:#f6f6f6;padding:10px">
    <div class="card">
      <!-- 搜索条件 -->
      <div style="display:flex;align-items:center;gap:10px;margin-bottom:15px;flex-wrap:wrap">
        <el-select v-model="query.lx" placeholder="收款类型" clearable style="width:140px" @change="onSearch">
          <el-option label="商品订单" value="spdd" />
          <el-option label="旅游订单收款" value="lydd" />
          <el-option label="到账公示" value="dzgs" />
        </el-select>
        <el-input v-model="query.khKey" placeholder="客户名称" clearable style="width:160px" @keyup.enter="onSearch" />
        <div style="width:220px;flex-shrink:0">
          <el-date-picker v-model="query.dateRange" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="YYYY-MM-DD" style="width:100%" @change="onSearch" />
        </div>
        <el-button type="primary" @click="onSearch">查询</el-button>
        <el-button type="success" @click="onExport">导出</el-button>
      </div>
      <!-- 表格 -->
      <el-table :data="list" v-loading="loading" style="width:100%" stripe>
        <el-table-column type="index" label="序号" width="60" align="center" />
        <el-table-column label="类型" prop="Lx" width="110" />
        <el-table-column label="商品名称" min-width="180">
          <template #default="{ row }">{{ row.SpMc || '-' }}</template>
        </el-table-column>
        <el-table-column label="来源" width="110">
          <template #default="{ row }">{{ row.Ly || '-' }}</template>
        </el-table-column>
        <el-table-column label="编号" prop="Bh" width="180" />
        <el-table-column label="客户/付款人" prop="KhMc" min-width="120" />
        <el-table-column label="销售价" width="100" align="right">
          <template #default="{ row }">{{ Number(row.Je).toFixed(2) }}</template>
        </el-table-column>
        <el-table-column label="已收款" width="100" align="right">
          <template #default="{ row }">
            <span style="color:#67c23a">{{ row.Ysje != null ? Number(row.Ysje).toFixed(2) : '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="手续费" width="100" align="right">
          <template #default="{ row }">
            <span v-if="row.SxfJe != null && Number(row.SxfJe) > 0">{{ Number(row.SxfJe).toFixed(2) }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="分销返佣" width="100" align="right">
          <template #default="{ row }">
            <span v-if="row.Fxje != null && Number(row.Fxje) > 0">{{ Number(row.Fxje).toFixed(2) }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="实际到账" width="100" align="right">
          <template #default="{ row }">
            <span style="color:#e6a23c" v-if="row.SxfJe != null">
              {{ (Number(row.Ysje || 0) - Number(row.SxfJe || 0) - Number(row.Fxje || 0)).toFixed(2) }}
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="优惠额" width="100" align="right">
          <template #default="{ row }">{{ row.Yhqje != null && row.Yhqje > 0 ? Number(row.Yhqje).toFixed(2) : '-' }}</template>
        </el-table-column>
        <el-table-column label="结算价" width="100" align="right">
          <template #default="{ row }">{{ row.Jsj != null ? Number(row.Jsj).toFixed(2) : '-' }}</template>
        </el-table-column>
        <el-table-column label="状态" width="100" align="center">
          <template #default="{ row }">
            <el-tag :type="statusType(row.Zt)" size="small" effect="plain">{{ row.Zt }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="时间" width="170">
          <template #default="{ row }">{{ formatTime(row.Sj) }}</template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div style="display:flex;justify-content:flex-end;margin-top:10px">
        <el-pagination
          v-model:current-page="query.page"
          :page-size="query.limit"
          :total="total"
          layout="total, prev, pager, next"
          @current-change="onLoad"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { caiwu_shoukuan, caiwu_shoukuan_export } from "@/http/api";
import dayjs from "dayjs";

export default {
  setup() {
    const query = reactive({ lx: "", khKey: "", dateRange: null, page: 1, limit: 20 });
    const list = ref([]);
    const total = ref(0);
    const loading = ref(false);

    const formatTime = (t) => t ? dayjs(t).format("YYYY-MM-DD HH:mm") : "";

    const statusType = (zt) => {
      const map = {
        '待确认': 'info', '待支付': 'warning', '部分支付': '',
        '已支付': 'success', '已取消': 'danger', '待使用': '',
        '已完成': 'success', '已退款': 'danger', '审核不通过': 'danger',
        '待审核': 'warning', '已通过': 'success', '已作废': 'info',
      };
      return map[zt] || '';
    };

    const onLoad = () => {
      loading.value = true;
      const params = { page: query.page, limit: query.limit };
      if (query.lx) params.lx = query.lx;
      if (query.khKey) params.khKey = query.khKey;
      if (query.dateRange) {
        params.startDate = query.dateRange[0];
        params.endDate = query.dateRange[1];
      }
      caiwu_shoukuan(params).then(res => {
        loading.value = false;
        if (res.status == 200) {
          list.value = res.data.data || [];
          total.value = res.data.total || 0;
        }
      }).catch(() => { loading.value = false; });
    };

    const onSearch = () => { query.page = 1; onLoad(); };

    const onExport = () => {
      const params = {};
      if (query.lx) params.lx = query.lx;
      if (query.khKey) params.khKey = query.khKey;
      if (query.dateRange) {
        params.startDate = query.dateRange[0];
        params.endDate = query.dateRange[1];
      }
      caiwu_shoukuan_export(params).then((res) => {
        if (res.status == 200) {
          var blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob);
          downloadElement.href = href;
          downloadElement.download = "收款明细表.xlsx";
          document.body.appendChild(downloadElement);
          downloadElement.click();
          document.body.removeChild(downloadElement);
          window.URL.revokeObjectURL(href);
        }
      });
    };

    onMounted(() => onLoad());

    return { query, list, total, loading, onLoad, onSearch, onExport, formatTime, statusType };
  },
};
</script>

<style scoped>
.card { background:#fff;border-radius:7px;padding:20px; }
</style>
